import { Grid } from "@mui/material";
import CustomFormField from "components/CustomFormField";
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import PropTypes from "prop-types";
import { useEffect } from "react";
import { connect } from "react-redux";
import { GRADES } from "redux/actions/constants";

const ClassForm = ({
  formData,
  localizations,
  allOrganizations,
  subOrganizations,
  isEditMode,
  onOrganizationChange,
  lookups,
}) => {
  const {
    formField,
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    setFieldValue,
    setFieldTouched,
  } = formData;

  const {
    className: { errorMsg: _className, ...classNameRest },
    classLevel: { errorMsg: _classLevel, ...classLevelRest },
    organization: { errorMsg: _organization, ...organizationRest },
    subOrganization: { errorMsg: _subOrganization, ...subOrganizationRest },
  } = formField;

  const {
    className: classNameV,
    classLevel: classLevelV,
    organization: organizationV,
    subOrganization: subOrganizationV,
  } = values;

  useEffect(() => {
    const orgId = organizationV?.value || organizationV;

    if (orgId && !isEditMode) {
      onOrganizationChange(orgId);
    }
  }, [organizationV, isEditMode]);

  return (
    <>
      <SuiTypography variant="h5">
        {localizations?.CLASS_FORM_HEADER ?? "Class Details"}
      </SuiTypography>
      <SuiBox mt={1} mb={5}>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={4}>
            <SuiBox
              sx={{
                cursor: isEditMode ? "not-allowed" : "default",
              }}
            >
              <CustomFormField
                {...organizationRest}
                options={
                  Array.isArray(allOrganizations) && allOrganizations?.length > 0
                    ? allOrganizations.map((organization) => ({
                        value: organization.id,
                        label: organization.organizationKey,
                      }))
                    : []
                }
                resets={[{ name: "subOrganization", value: null }]}
                value={organizationV}
                error={errors.organization?.length > 0 && !(touched.organization !== true)}
                success={organizationV?.length > 0 && !errors.organization}
                setFieldValue={setFieldValue}
                setFieldTouched={setFieldTouched}
                isDisabled={isEditMode}
              />
            </SuiBox>
          </Grid>
          <Grid item xs={12} lg={4}>
            <SuiBox
              sx={{
                cursor: isEditMode ? "not-allowed" : "default",
              }}
            >
              <CustomFormField
                {...subOrganizationRest}
                options={
                  Array.isArray(subOrganizations) && subOrganizations?.length > 0
                    ? subOrganizations.map((subOrganization) => ({
                        value: subOrganization.id,
                        label: subOrganization.subOrganizationKey,
                      }))
                    : []
                }
                value={subOrganizationV}
                error={errors.subOrganization?.length > 0 && !(touched.subOrganization !== true)}
                success={subOrganizationV?.length > 0 && !errors.subOrganization}
                setFieldValue={setFieldValue}
                setFieldTouched={setFieldTouched}
                isDisabled={isEditMode || !organizationV}
              />
            </SuiBox>
          </Grid>
          <Grid item xs={12} lg={4}>
            <CustomFormField
              {...classNameRest}
              value={classNameV}
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors.className?.length > 0 && touched.className}
              success={classNameV?.length > 0 && !errors.className}
            />
          </Grid>
          <Grid item xs={12} lg={4}>
            <CustomFormField
              {...classLevelRest}
              options={lookups.l_grades?.lookupValues?.map((lv) => ({
                value: lv.lookupValueKey,
                label: lv.lookupValueKey,
              }))}
              value={classLevelV}
              setFieldValue={setFieldValue}
              setFieldTouched={setFieldTouched}
              error={errors.classLevel?.length > 0 && touched.classLevel}
              success={classLevelV?.length > 0 && !errors.classLevel}
            />
          </Grid>
        </Grid>
      </SuiBox>
    </>
  );
};

ClassForm.defaultProps = {
  localizations: null,
  allOrganizations: null,
  subOrganizations: null,
  isEditMode: false,
  onOrganizationChange: () => {},
  lookups: {},
};

ClassForm.propTypes = {
  formData: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
  localizations: PropTypes.objectOf(PropTypes.any),
  allOrganizations: PropTypes.arrayOf(PropTypes.any),
  subOrganizations: PropTypes.arrayOf(PropTypes.any),
  isEditMode: PropTypes.bool,
  onOrganizationChange: PropTypes.func,
  lookups: PropTypes.objectOf(PropTypes.any),
};

const mapStateToProps = (state) => {
  let lookups = {};
  if (state.data.lookups && Object.keys(state.data.lookups).length !== 0) {
    lookups = {
      l_grades: state.data.lookups[GRADES],
    };
  }

  return {
    localizations: state.localization?.pairs,
    lookups,
  };
};

export default connect(mapStateToProps, null)(ClassForm);
